module.exports = __webpack_public_path__ + "img/Stage_1_Diff.80bcc9bc.jpg";